// extracted by mini-css-extract-plugin
module.exports = {"aspectRatio":"aspect-ratio-module--aspectRatio--3t1xg"};